<template>
  <el-dialog
    title="选择商品"
    :visible.sync="dialogVisible"
    width="70%"
    @close="handleClose">
    <!-- 这里添加商品选择的具体内容 -->
    <div class="product-select-container">
      <el-row :gutter="20">
        <el-col :span="24">
          <el-table
            :data="productList"
            border
            style="width: 100%"
            @selection-change="handleSelectionChange">
            <el-table-column
              type="selection"
              width="55">
            </el-table-column>
            <el-table-column
              prop="productId"
              label="商品编号"
              width="120">
            </el-table-column>
            <el-table-column
              prop="prodName"
              label="商品名称">
            </el-table-column>
            <el-table-column
              prop="specName"
              label="规格">
            </el-table-column>
            <el-table-column
              prop="price"
              label="单价">
            </el-table-column>
            <el-table-column
              prop="stock"
              label="库存">
            </el-table-column>
          </el-table>
        </el-col>
      </el-row>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取 消</el-button>
      <el-button type="primary" @click="handleConfirm">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { queryProductList } from '@/api/goods/assetInventoryApi'

export default {
  name: 'ChooseProductAndSpec',
  data() {
    return {
      dialogVisible: false,
      productList: [],
      selectedProducts: [],
      params: {}
    }
  },
  methods: {
    open(params) {
      this.params = params || {}
      this.dialogVisible = true
      this.loadProductList()
    },
    loadProductList() {
      queryProductList(this.params).then(res => {
        this.productList = res.data
      }).catch(err => {
        console.error('加载商品列表失败:', err)
      })
    },
    handleSelectionChange(val) {
      this.selectedProducts = val
    },
    handleConfirm() {
      if (this.selectedProducts.length === 0) {
        this.$message.warning('请至少选择一件商品')
        return
      }
      this.$emit('chooseProductAndSpec', this.selectedProducts)
      this.dialogVisible = false
    },
    handleClose() {
      this.selectedProducts = []
      this.params = {}
    }
  }
}
</script>

<style scoped>
.product-select-container {
  padding: 20px;
}
</style>